import { Injectable } from "@angular/core";
import { FocusFieldStrategy } from "../directives/navigation-section.directive";
import { BaseNavigationStrategyService } from "./base-navigation-strategy.service";
import { NavigationService } from "./navigation.service";

@Injectable()
export class LeftRightToolbarUpDownFieldsNavigationStrategy extends BaseNavigationStrategyService {
    private findNextValidSection(startIndex: number, direction: 'forward' | 'backward'): number {
        let targetIndex = direction === 'forward' ? startIndex + 1 : startIndex - 1;
        const length = this.navigationService.fieldsSections?.length ?? 0;
        let visited = 0;

        if (direction === 'forward') {
            while (visited < length) {
                if (targetIndex >= length) {
                    targetIndex = 0;
                }
                if (!(this.navigationService.getFieldsFromSection(this.navigationService.fieldsSections[targetIndex])?.length === 0 ||
                    this.navigationService.fieldsSections[targetIndex].isToolbar)) {
                    return targetIndex;
                }
                targetIndex++;
                visited++;
            }
        } else {
            while (visited < length) {
                if (targetIndex < 0) {
                    targetIndex = length - 1;
                }
                if (!(this.navigationService.getFieldsFromSection(this.navigationService.fieldsSections[targetIndex])?.length === 0 ||
                    this.navigationService.fieldsSections[targetIndex].isToolbar)) {
                    return targetIndex;
                }
                targetIndex--;
                visited++;
            }
        }
        return startIndex;
    }

    handleKeyPress(event: KeyboardEvent): void {
        if (NavigationService.LEFT_KEY.includes(event.keyCode)) {
            this.moveToPreviousToolbarField(FocusFieldStrategy.RememberLastField);
        } else if (NavigationService.RIGHT_KEY.includes(event.keyCode)) {
            this.moveToNextToolbarField(FocusFieldStrategy.RememberLastField);
        } else if (NavigationService.UP_KEY.includes(event.keyCode)) {
            if (this.navigationService.activeSection?.isToolbar) {

                //Se siamo in una toolbar e non ci sono altre section nel container, non facciamo nulla
                if (this.navigationService.sectionsFromActiveContainer.length <= 1) {
                    return;
                }

                if (this.navigationService.activeSection != null) {
                    this.navigationService.activeSection.blur();
                }

                if (this.navigationService.fieldsSections?.length > 0) {
                    if (this.navigationService.lastFieldsSection) {
                        this.navigationService.lastFieldsSection.onFocus(FocusFieldStrategy.RememberLastField);
                    } else {
                        this.navigationService.fieldsSections[0].onFocus(FocusFieldStrategy.RememberLastField);
                    }
                }
            } else {
                const success = this.moveToPreviousField(event);

                if (success == false && this.navigationService.fieldsSections?.length > 1) {
                    const currentIndex = this.navigationService.fieldsSections.findIndex(section =>
                        section.sectionId === this.navigationService.activeSection?.sectionId
                    );

                    const targetIndex = this.findNextValidSection(currentIndex, 'backward');
                    this.navigationService.fieldsSections[targetIndex].onFocus(FocusFieldStrategy.Last);
                }
            }
        } else if (NavigationService.DOWN_KEY.includes(event.keyCode)) {
            if (this.navigationService.activeSection?.isToolbar) {

                //Se siamo in una toolbar e non ci sono altre section nel container, non facciamo nulla
                if (this.navigationService.sectionsFromActiveContainer.length <= 1) {
                    return;
                }

                if (this.navigationService.activeSection != null) {
                    this.navigationService.activeSection.blur();
                }

                if (this.navigationService.fieldsSections?.length > 0) {
                    if (this.navigationService.lastFieldsSection) {
                        this.navigationService.lastFieldsSection.onFocus(FocusFieldStrategy.RememberLastField);
                    } else {
                        this.navigationService.fieldsSections[0].onFocus(FocusFieldStrategy.RememberLastField);
                    }
                }
            } else {
                const success = this.moveToNextField(event);
                if (success === false && this.navigationService.fieldsSections?.length > 1) {
                    const currentIndex = this.navigationService.fieldsSections.findIndex(section =>
                        section.sectionId === this.navigationService.activeSection?.sectionId
                    );

                    const targetIndex = this.findNextValidSection(currentIndex, 'forward');
                    this.navigationService.fieldsSections[targetIndex].onFocus(FocusFieldStrategy.First);
                }
            }
        }
    }
}
